import React, { useState, useEffect } from 'react';
import { connect } from "react-redux";
import { useHistory } from 'react-router-dom';

import * as LoginActions from './actions';

import LoginNavBar from '../navigation/LoginNavBar';
import ProgressBar from './ProgressBar';
import ChangePassword from './ChangePassword';

import classNames from 'classnames';

import Button from '../components/Button';

import '../css/login.css';

const SignupPage = ({
  dispatch,
  signupConfirms,
  signupConfirming,
  correctUsername,
  correctPassword,
  handleConfirmSubmit,
  handleCancelSubmit,
  handleChange,
  handleSubmit,
  loginResult,
  granting,
  committing,
  completed,
  navBarWidth,
  navBarHeight,
  navBarActive
}) => {
  const style = navBarActive ? {} : { top: navBarHeight };

  const classes = {
    modal: (v) => v ? 'bg-navy-muted' : 'bg-navy'
  }
  const [ signupConfirmModal, setSignupConfirmModal ] = useState(null);
  const [ progressModal, setProgressModal ] = useState(null);
  const [ modalDisplayed, setModalDisplayed ] = useState(false);
  const [ changeModal, setChangeModal ] = useState(null);
  const [ willChangePassword, setWillChangePassword ] = useState(false);

  const modalSizeX = "768px";
  const modalSizeY = "256px";
  const signupConfirmsSizeX = "128px";

  const [ finetune, setFinetune ] = useState({
    finetuneX: window.innerWidth,
    finetuneY: window.innerHeight,
  });

  const handleResize = () => {
    setFinetune({
      finetuneX: window.innerWidth,
      finetuneY: window.innerHeight
    });
  }

  useEffect(() => {
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    }
  }, [window.innerWidth, window.innerHeight]);

  const history = useHistory();

  const next = () => {
    setProgressModal(null);
    setModalDisplayed(false);
    setWillChangePassword(true);
  }

  const close = () => {
    setChangeModal(null);
    setWillChangePassword(false);
    dispatch(notifyCompleteConfiguration());
    history.push("/login");
  }

  useEffect(() => {
    if (signupConfirming)
      setSignupConfirmModal(
        <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
          <div id='modal' className='modal-signup'>
            <div className='flex flex-column justify-center items-center' style={{ width: modalSizeX, height: modalSizeY }}>
              <div className='times-new-roman mb2 f4 white'>Are you sure to sign up?</div>
              <div className='flex justify-center items-centerm mt2'>
                <Button className='ma2 times-new-roman' onClick={handleConfirmSubmit} style={{ width: signupConfirmsSizeX }}>CONFIRM</Button>
                <Button className='ma2 times-new-roman' onClick={handleCancelSubmit} style={{ width: signupConfirmsSizeX }}>CANCEL</Button>
              </div>
            </div>
          </div>
        </div>
      );
    else
      setSignupConfirmModal(null);
  }, [signupConfirming]);

  useEffect(() => {
    if (granting || committing || completed) {
      setProgressModal(
        <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
          <div id='modal' className='modal-signup'>
            <div className='flex flex-column justify-center items-center'>
              <ProgressBar />
              <Button className='mb4' onClick={next} disabled={granting || committing}>Next</Button>
            </div>
          </div>
        </div>
      )
      setModalDisplayed(true);
    }
  }, [granting, committing]);

  useEffect(() => {
    if (!modalDisplayed)
      return;

    setProgressModal(
      <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
        <div id='modal' className='modal'>
          <div className='flex flex-column justify-center items-center'>
            <ProgressBar />
            <Button className='mb4' onClick={next} disabled={granting || committing}>Next</Button>
          </div>
        </div>
      </div>
    )
  }, [window.innerWidth, window.innerHeight]);

  useEffect(() => {
    if (!willChangePassword)
      return;

    setChangeModal(
      <div id='overlay' className='overlay' style={{ width: finetune.finetuneX, height: finetune.finetuneY}}>
        <div id='modal' className='modal'>
          <div className='flex flex-column justify-center items-center'>
            <ChangePassword
              close={close}
            />
          </div>
        </div>
      </div>
    )
  }, [willChangePassword]);

  return (
    <div className='new-times-roman h-100'>
      {signupConfirmModal}
      {progressModal}
      {changeModal}
      <div className='flex flex-row-reverse-l flex-column-reverse justify-end justify-start-l' style={{ minHeight: '100vh' }}>
        <div className='flex-auto-l bg-navy' style={{ width: finetune.finetuneX, height: finetune.finetuneY }}>
          <main className='pa0-l'>
            <div className='relative' style={style}>
              <div className='mt5 flex flex-column flex-wrap items-center' style={{ overflowY: 'auto' }}>
                <div className='bg-white pa3'>
                  <div className='flex justify-between items-center'>
                    <div className='flex' style={{ width: '96px' }}></div>
                    <div className='flex items-center times-new-roman pa3 fw4 f3 charcoal'>Get Started</div>
                    <div className='flex justify-between'>
                      <div className='flex justfy-end' style={{ width: '96px' }}>
                      </div>
                    </div>
                  </div>
                  <div className='flex flex-column'>
                    { (!correctUsername || !correctPassword) && <div className='tc mt3 mb3 pt3 pb3 border-red bg-red-100' >
                        <span className='text-red-500'>Invalid signup.</span>
                      </div> }
                    <form className='flex flex-column' onSubmit={handleSubmit}>
                      <div className='charcoal f5 mb2'>EMAIL</div>
                      <input
                        type="text"
                        name="emailAddress"
                        placeholder="Specify your e-mail address"
                        onChange={handleChange}
                        className='b--gray mb4'
                        style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                      />
                      <div className='charcoal f5 mb2'>PASSWORD</div>
                      <input
                        type="password"
                        name="password"
                        placeholder="Specify your password"
                        autoComplete="off"
                        onChange={handleChange}
                        className='b--gray mb4'
                        style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                      />
                      <input
                        type="password"
                        name="altPassword"
                        placeholder="Confirm your password"
                        autoComplete="off"
                        onChange={handleChange}
                        className='b--gray mb4'
                        style={{ width: '400px', borderStyle: 'solid', borderWidth: '1px', padding: '8px', outline: '#FF0000' }}
                      />
                      <Button type="submit" className='times-new-roman mb4' style={{ padding: '8px' }} >SIGN UP</Button>
                   </form>
                  </div>
                </div>
                <div className='pa3 times-new-roman white'>Already have an account? <button className='times-new-roman white underline' onClick={() => history.push("/login")}>Log in</button></div>
              </div>
            </div>
          </main>
        </div>
        { !loginResult && navBarActive
        ? <div className='flex-none-l z-2 navbar-container bg-navy-nav'>
            <LoginNavBar />
          </div>
        : !loginResult && <div className='fixed z-2 navbar-container flex-none-l bg-navy-nav' style={{ width: navBarWidth, height: navBarHeight }}>
          <LoginNavBar />
        </div> }
      </div>
    </div>
  )
}

const notifyCompleteConfiguration = () => {
  return {
    type: LoginActions.SIGNUP_CONFIGURATION_COMPLETE
  }
}

const mapStateToProps = state => ({
  loginResult: state.login.loginResult,
  granting: state.login.granting,
  committing: state.login.committing,
  completed: state.login.completed,
  navBarWidth: state.navigation.navBarWidth,
  navBarHeight: state.navigation.navBarHeight,
  navBarActive: state.navigation.navBarActive
});

export default connect(mapStateToProps)(SignupPage);
